import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";
import { Text } from "@/components/Text";
import { Flex } from "@/eworkitComponents";

import "./_email-message.scss";

export interface IEmailMessageProps {
  handleResend?: () => void;
  message?: string;
  resendDisabled?: boolean;
}

export const EmailMessage: FunctionComponent<IEmailMessageProps> = ({
  children,
  handleResend,
  message,
  resendDisabled,
}) => {
  const { t } = useTranslation("public");

  return (
    <Flex padding={["xl", "xl", false]} direction="column" align="center">
      {children}

      {handleResend && (
        <Flex margin={["xl", false, false, false]} direction="column" innerMargin="md" align="center">
          <Button variant="secondary" size="lg" disabled={resendDisabled} onClick={handleResend} testName="resend">
            <Text color="dark-cyan" size="lg">
              {t("COMPONENTS.BUTTON_RESEND")}
            </Text>
          </Button>

          {message && (
            <Text size="lg" align="center" color="dark-cyan">
              {message}
            </Text>
          )}
        </Flex>
      )}
    </Flex>
  );
};
